import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DeleteAccountPage } from "./-components/DeleteAccountPage";
import { setProfileSubPageBodyColors } from "./-utils/profileHost";

const DeleteAccountSearch = z.object({
    step: z.enum(["info", "confirm", "done"]).optional(),
});

export const Route = createFileRoute("/profile/delete-account")({
    validateSearch: DeleteAccountSearch,
    component: DeleteAccountRoute,
    beforeLoad: () => {
        setProfileSubPageBodyColors(
            "var(--color-background-profile-secondary)",
            "var(--color-background-profile-secondary)",
        );
    },
    head: ({ match }) => ({
        meta: [
            { title: `Delete account - ${match.search.tenant} ${match.search.locale}` },
        ],
    }),
});

function DeleteAccountRoute() {
    const { step = "info" } = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
        <DeleteAccountPage
            step={step}
            onStepChange={(nextStep) => {
                void navigate({
                    search: (current) => ({ ...current, step: nextStep }),
                    replace: true,
                });
            }}
        />
    );
}
